module.exports = __webpack_public_path__ + "static/media/brainLayout.5b98449f.png";